export const Logo = ({ light = false, size = "text-2xl" }) => (
  <span data-testid="brand-logo" className={`font-extrabold tracking-tight ${size} ${light ? "text-white" : "text-[#12343B]"}`}>
    normah<span className="text-[#00FF40]" style={{ textShadow: light ? "none" : "0 0 1px #12343B" }}>.</span>
  </span>
);

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <span className={`inline-flex items-center justify-center rounded-xl bg-[#12343B] ${className}`}>
    <span className="text-lg font-extrabold text-[#81D8D0]">n<span className="text-[#00FF40]">.</span></span>
  </span>
);
